<template>
  <section class="role-school">
    <v-expand-transition>
      <v-card flat style="transition: 2s linear 1s;">
        <v-row no-gutters>
          <v-col cols="12">
            <v-select
              v-model="role"
              v-validate="'required'"
              :error-messages="errors.collect('role')"
              label="Current role"
              hint="Enter your current role"
              data-vv-name="role"
              data-vv-as="current role"
              required
              :items="roles"
            ></v-select>
          </v-col>
          <transition name="slide-y-transition" mode="out-in">
            <v-col
              cols="12"
              v-if="schoolRoles.includes(role)"
              key="searchSchoolPostcode"
            >
              <search-school-postcode
                ref="searchSchoolPostcode"
                v-model="school"
              />
            </v-col>
            <v-col
              cols="12"
              v-else-if="postcodeTextRoles.includes(role)"
              key="organization"
            >
              <input-postcode-name
                ref="inputPostcodeName"
                v-model="school"
                :label="roleLabel"
                :withName="!(role === 'casual' || role === 'parent')"
              />
            </v-col>
          </transition>
        </v-row>
      </v-card>
    </v-expand-transition>
  </section>
</template>

<script>
import SearchSchoolPostcode from '@/components/SearchSchoolPostcode'
import InputPostcodeName from './InputPostcodeName'
import { mapMutations } from 'vuex'

export default {
  name: 'RoleInfo',
  $_veeValidate: {
    validator: 'new'
  },
  components: {
    SearchSchoolPostcode,
    InputPostcodeName
  },
  computed: {
    items() {
      if (!this.schools.data) return []

      const entries = Object.entries(this.schools.data)

      return entries.map(school => {
        return {
          id: school[0],
          value: school[1]
        }
      })
    },
    roleLabel() {
      if (this.role === 'organization_company') {
        return 'Organization/Company'
      } else if (this.role === 'home_distance') {
        return 'Institution'
      } else if (this.role === 'pre_service_teacher') {
        return 'University/TAFE'
      } else {
        return 'Other Institution'
      }
    }
  },
  watch: {
    role() {
      this.reset()
    }
  },
  data() {
    return {
      role: null,
      school: null,
      roles: [
        {
          text: 'Teacher',
          value: 'teacher'
        },
        {
          text: 'Casual Teacher',
          value: 'casual'
        },
        {
          text: 'School Leader / Principal',
          value: 'school_leader_principal'
        },
        {
          text: 'School Admin',
          value: 'school_admin'
        },
        {
          text: 'Home school / Distance Educator',
          value: 'home_distance'
        },
        {
          text: 'Pre-service Teacher',
          value: 'pre_service_teacher'
        },
        {
          text: 'Organization / Company',
          value: 'organization_company'
        },
        {
          text: 'Parent',
          value: 'parent'
        },
        {
          text: 'Other',
          value: 'other'
        }
      ],
      schoolRoles: ['teacher', 'school_leader_principal', 'school_admin'],
      postcodeTextRoles: [
        'casual',
        'home_distance',
        'organization_company',
        'pre_service_teacher',
        'parent',
        'other'
      ],
      universityRoles: ['pre_service_teacher']
    }
  },
  methods: {
    ...mapMutations('snackbar', ['showSnackbar', 'showErrorSnackbar']),
    reset() {
      this.roleInfo = null
    },
    async validate() {
      let result = await this.$validator.validateAll()
      if (!result) return false

      if (this.role) {
        if (this.schoolRoles.includes(this.role)) {
          result = await this.$refs.searchSchoolPostcode.validate()
        } else if (this.postcodeTextRoles.includes(this.role)) {
          result = await this.$refs.inputPostcodeName.validate()
        } else if (this.universityRoles.includes(this.role)) {
          result = await this.$refs.searchUniversityPostcode.validate()
        }
        if (!result) return false
      }

      if (result) this.getInfo()
      return true
    },
    getInfo() {
      let selectedSchool = this.school.school ? this.school.school : null
      const info = {
        role: this.role,
        school: this.school.school,
        postcode: this.school.postcode,
        country: this.school.country ? this.school.country : 'AU',
        name: selectedSchool ? selectedSchool.text : this.school.name,
        state: this.school.state ? this.school.state : null,
        university: this.school.university ? this.school.university : null
      }
      this.$emit('input', info)
      return info
    }
  }
}
</script>

<style lang="scss">
.role-school {
}
</style>
